import classes from "./SectionLeft.module.css";
import {IconCreditCard} from "@tabler/icons-react";
import {useContext} from "react";
import QRCodeViewItemContext from "../../QRCodeViewItemContext";
import QRCodeHelper from "../../../../../../../helpers/qr-code/QRCodeHelper";
import {useMediaQuery} from "@mantine/hooks";

/**
 * Left section of QRCodeViewItem
 * @author Kacper Faber
 * @since 0.1.9
 */
function SectionLeft() {
    /**
     * QRCodeViewItemContext
     * @author Kacper Faber
     * @since 0.1.9
     */
    const ctx = useContext(QRCodeViewItemContext);
    const isSmallScreen = useMediaQuery(("(max-width: 1024px)"));

    /**
     * Converts QRCode kind to human-readable text.
     * @author Kacper Faber
     * @since 0.1.9
     */
    const renderKind = () => {
        return QRCodeHelper.getKindText(ctx.qrCode?.kind);
    }

    return (
        <div className={classes.root}>
            <div className={classes.kind}>
                { renderKind() }
            </div>

            <div className={classes.titleContainer}>
                <div className={classes.titleIcon}>
                    <IconCreditCard/>
                </div>

                <div className={classes.title}>
                    {ctx.qrCode?.name}
                </div>
            </div>
        </div>
    );
}

export default SectionLeft;